import request from "@/utils/request";

const api = {
  getCompanySetting: "/company/setting",
};

export function getCompanySetting(parameter) {
  return request({
    url: api.getCompanySetting,
    method: "get",
    params: parameter,
  });
}
